import React from 'react'

export function PlusIcon (): React.JSX.Element {
  // https://fontawesome.com/icons/classic/light/plus
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.7592 0.807692V0H6.15385V0.807692V6.19231H0.802676H0V7.80769H0.802676H6.15385V13.1923V14H7.7592V13.1923V7.80769H13.1104H13.913V6.19231H13.1104H7.7592V0.807692Z" fill="white"/>
    </svg>
  )
}
